import { useState } from 'react';
import queryString from 'query-string';
import moment from 'moment-timezone';
import { PayloadStates } from '@lore/utils';
import useStewardshipFilter from '@/pages/events/useStewardshipFilter';
import REQUIRED_FIELDS_PUBLIC from '@/pages/events/REQUIRED_FIELDS_PUBLIC';
import { useConnect } from '@hooks/@lore/query-connect';

export default function useQuery(props) {
  const { location, PAGE_SIZE = 10 } = props;

  const [timestamp] = useState(moment().toISOString());
  const stewardshipFilter = useStewardshipFilter();

  return useConnect('event.find', {
    where: {
      eager: {
        $where: {
          // published: false,
          cancelled: false,
          createdAt: {
            $gte: moment(timestamp).subtract(1, 'weeks').toISOString()
          },
          $and: REQUIRED_FIELDS_PUBLIC.$and,
          $or: stewardshipFilter
        }
      }
    },
    pagination: {
      page: queryString.parse(location.search).page || '1',
      pageSize: PAGE_SIZE,
      order: 'createdAt desc'
    },
    exclude: function (model) {
      return model.state === PayloadStates.DELETED;
    }
  }, {
    keepPreviousData: true
  });
}